import { images } from "@/assets";
import { FormSectionHeader } from "@/components";
import { cn, formatAmount } from "@/lib/utils";

const InvoiceStatus = ({ statusCards }: any) => {
  return (
    <div className="mt-[10px]">
      <FormSectionHeader>Invoice Status Overview</FormSectionHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mb-10 rounded-md overflow-hidden">
        {statusCards?.map((obj: any, index: number) => (
          <div className="bg-primary p-5">
            <div
              className={cn(
                "flex flex-row gap-5 text-white",
                index !== statusCards.length - 1 && "md:border-r-1"
              )}
              key={`status-${index}`}
            >
              <div className="h-[60px] w-[60px] bg-white p-3 flex items-center justify-center rounded-full">
                <img src={images.check_doc} />
              </div>
              <div className="flex flex-col text-[14px]">
                <span>
                  {obj?.invoices?.title}: {obj?.invoices?.count}
                </span>
                <span>
                  {obj?.vendors?.title}: {obj?.vendors?.count}
                </span>
                <span>
                  {obj?.amount?.title}: {formatAmount(obj?.amount?.count || 0)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceStatus;
